import JSONApiService from "@/services/JSONApiService";
import { include, PAGES } from "@/models/relationships";
import { MICROSITE_MODEL } from "@/models/microsite-model";
import { MICROSITE_PAGE_MODEL } from "@/models/microsite-page-model";

const micrositeApi = commit => ({
  getAll: params =>
    JSONApiService(commit)
      .all(MICROSITE_MODEL)
      .get({ ...params }),
  getCurrentMicrosite: id =>
    JSONApiService(commit)
      .one(MICROSITE_MODEL, id)
      .get(),
  getCurrentMicrositePages: id =>
    JSONApiService(commit)
      .one(MICROSITE_MODEL, id)
      .all("page")
      .get({ sort: "displayOrder" }),
  add: data => JSONApiService(commit).create(MICROSITE_MODEL, data),
  edit: data =>
    JSONApiService(commit)
      .one(MICROSITE_MODEL, data.id)
      .patch(data, include(PAGES)),
  addPage: data => JSONApiService(commit).create(MICROSITE_PAGE_MODEL, data),
  editPage: data =>
    JSONApiService(commit)
      .one(MICROSITE_PAGE_MODEL, data.id)
      .patch(data),
  deletePage: id =>
    JSONApiService(commit)
      .one(MICROSITE_PAGE_MODEL, id)
      .destroy()
});

export default micrositeApi;
